import React from "react";
import { faCheck, faEllipsis, faExclamationCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    getFatigueColor,
    getFatigueStatus,
    getHStatusColor,
    getRiskColor,
    getRiskStatus,
    getSStatus,
    getSStatusColor,
    getTStatus,
    getTStatusColor,
} from "../../../../../utils/statusUtils";

const WorkersTable = ({ shift }: any) => {
    const getWorkerStyle = (worker: any) => ({
        color: worker.h_Color === 3 ? 'red' : 'black',
        fontWeight: worker.h_Color === 3 ? 600 : 400,
        backgroundColor: worker.paid
            ? 'lightgreen'
            : worker.colorIdentifier || ''
    });

    const workerStyle = (worker: any) => ({
        backgroundColor: worker.colorIdentifier,
        color: worker.h_Color === 3 ? 'red' : 'black',
        fontWeight: worker.h_Color === 3 ? 600 : 400,
    });

    function formatDecimalHours(dec: any) {
        const sign = dec < 0 ? "-" : "";
        const abs = Math.abs(dec);

        let hours = Math.floor(abs);
        let minutes = Math.round((abs - hours) * 60);
        if (minutes === 60) {
            minutes = 0;
            hours += 1;
        }

        return minutes === 0
            ? `${sign}${hours}h`
            : `${sign}${hours}h ${String(minutes).padStart(2, "0")}m`;
    }

    return (
        <div className="worker-table">
            <div className="worker-header">ROLE</div>
            <div className="worker-header">FULL NAME</div>
            <div className="worker-header">PTS</div>
            <div className="worker-header">NUMBER</div>
            <div className="worker-header">T</div>
            <div className="worker-header">S</div>
            <div className="worker-header">H</div>
            <div className="worker-header">F</div>
            <div className="worker-header">R</div>
            <div className="worker-header">D</div>
            <div className="worker-header">P</div>
            <div className="worker-header">NOTES</div>
            {shift.workers.map((worker: any) => (
                <React.Fragment key={worker.id}>
                    <div
                        className={`worker-data ${worker.paid && 'worker-paid'} text-align-left`}
                        style={getWorkerStyle(worker)}
                    >
                        {worker.workRole}
                    </div>
                    <div className="worker-data text-align-left" style={workerStyle(worker)}>
                        <div className="show-postcode">
                            <div className="postcode-hover">
                                <div style={{ display: "flex", justifyContent: 'space-between', alignItems: 'center' }}>
                                    {worker.fullName}
                                    {worker.hours > 55 &&
                                        <FontAwesomeIcon icon={faExclamationCircle} color={worker.hours >= 55 && worker.hours <= 61 ? "orange" : "red"} />
                                    }
                                </div>
                            </div>
                            {worker.hours !== -1 && shift.shiftStatus !== 2 && (
                                <div className="postcode-shown">
                                    {worker.h_Color === 3
                                        ? "Cancelled"
                                        : worker.isTraining
                                            ? "Training"
                                            : formatDecimalHours(Number(worker.hours).toFixed(1))
                                    }
                                </div>
                            )}
                        </div>
                    </div>
                    <div className="worker-data" style={workerStyle(worker)}>{worker.pts}</div>
                    <div className="worker-data" style={workerStyle(worker)}>
                        {worker.phoneNumber && (
                            <div className="show-postcode">
                                <div className="postcode-hover">
                                    {worker.phoneNumber}
                                </div>
                                {worker.postCode ? (
                                    <div className="postcode-shown">
                                        {worker.postCode}
                                    </div>
                                ) :
                                    <div className="postcode-shown">
                                        No Post Code
                                    </div>
                                }
                            </div>
                        )}
                    </div>
                    <div className="worker-data" style={{ backgroundColor: getTStatusColor(worker.t) }}>
                        {getTStatus(worker.t)}
                    </div>
                    <div className="worker-data" style={{ backgroundColor: getSStatusColor(worker.s) }}>
                        {getSStatus(worker.s)}
                    </div>
                    <div className="worker-data" style={{ backgroundColor: getHStatusColor(worker.h_Color) }}></div>
                    <div className="worker-data" style={{ backgroundColor: worker.userId ? getFatigueColor(worker, shift.startTime) : "white" }}>
                        {worker.userId && (
                            <div className="show-postcode">
                                <div className="postcode-hover">
                                    {getFatigueStatus(worker, shift.startTime)}
                                </div>
                                {worker.fatigueIndex !== undefined && !worker.isTraining && worker.h_Color !== 3 && (
                                    <div className="postcode-shown">
                                        {worker.fatigueIndex?.toFixed(1)}
                                    </div>
                                )}
                            </div>
                        )}
                    </div>
                    <div className="worker-data" style={{ backgroundColor: worker.userId ? getRiskColor(worker.riskIndex, worker.isTraining) : "white" }}>
                        {worker.userId && (
                            <div className="show-postcode">
                                <div className="postcode-hover">
                                    {getRiskStatus(worker.riskIndex, worker.isTraining)}
                                </div>
                                {(worker.riskIndex !== undefined && !worker.isTraining && worker.h_Color !== 3) && (
                                    <div className="postcode-shown">
                                        {worker.riskIndex?.toFixed(2)}
                                    </div>
                                )}
                            </div>
                        )}
                    </div>
                    <div className="worker-data" style={{ backgroundColor: worker.d ? '#87cefa' : 'white' }}>
                        {worker.d && <FontAwesomeIcon icon={faCheck} />}
                    </div>
                    <div className="worker-data">
                        {worker.paymentMethod?.displayName}
                    </div>
                    <div className="worker-data">
                        {worker.notes && (
                            <div className="show-notes">
                                <div className="notes-hover">
                                    <FontAwesomeIcon icon={faEllipsis} />
                                </div>
                                <div className="notes-shown">
                                    {worker.notes}
                                </div>
                            </div>
                        )}
                    </div>
                </React.Fragment>
            ))}
        </div>
    )
}

export default WorkersTable;
